"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WhatsAppCompartilhar = void 0;
var react_1 = __importStar(require("react"));
var Cores_1 = require("../../Cores/Cores");
var InputTelefone_1 = require("../../Inputs/InputTelefone/InputTelefone");
var Corpo_1 = require("../../Tipografia/Corpo/Corpo");
var InputDdi_1 = require("../../Inputs/InputTelefone/InputDdi/InputDdi");
var InputTextArea_1 = require("../../Inputs/InputTextArea/InputTextArea");
var listaCodigoInternacionalTelefone_1 = require("../../Inputs/InputTelefone/InputDdi/listaCodigoInternacionalTelefone");
var Botao_1 = require("../../Botao/Botao");
var Icone_1 = require("../../Icone/Icone");
var Chip_1 = require("../../Chip/Chip");
var HelperText_1 = require("../../HelperText/HelperText");
var globalMu_1 = __importDefault(require("../../../globalMu"));
var Divider_1 = require("../../Divider/Divider");
var Tooltip_1 = require("../../Tooltip/Tooltip");
var estiloWhatsAppCompartilhar = require("./WhatsAppCompartilhar.module.scss");
var WhatsAppCompartilhar = function (_a) {
    var listaTelefone = _a.listaTelefone, internacional = _a.internacional, _b = _a.quantidadeMaximaTelefones, quantidadeMaximaTelefones = _b === void 0 ? 10 : _b, // 👉 máximo 10 (1 principal + 9 cópias)
    valorDdi = _a.valorDdi, valorTelefone = _a.valorTelefone, mensagem = _a.mensagem, conteudoAjudaWhatsApp = _a.conteudoAjudaWhatsApp, onChangeDdi = _a.onChangeDdi, onChangeTelefone = _a.onChangeTelefone, onChangeMensagem = _a.onChangeMensagem, onAdicionarTelefone = _a.onAdicionarTelefone, onRemoveTelefone = _a.onRemoveTelefone, onSelectTelefone = _a.onSelectTelefone;
    var _c = react_1.default.useState(conteudoAjudaWhatsApp || undefined), ajudaWhatsApp = _c[0], setAjudaWhatsApp = _c[1];
    var renderTelefone = (react_1.default.createElement("div", { className: estiloWhatsAppCompartilhar.telefone },
        react_1.default.createElement("div", { className: estiloWhatsAppCompartilhar.campoTelefone },
            react_1.default.createElement(InputDdi_1.InputDdi, { regraTexto: function (country) {
                    return "+".concat(country.dialCode, " ").concat(country.country);
                }, opcoesMenu: listaCodigoInternacionalTelefone_1.listaCodigoInternacionalTelefone, placeholder: "Selecione um pa\u00EDs", id: "", desabilitado: false, onChange: onChangeDdi, valorInicial: valorDdi, tamanho: "small", menuProps: {
                    quebrarLinhas: true,
                    permitirPesquisa: true,
                }, botaoDeLimpar: true }),
            react_1.default.createElement(InputTelefone_1.InputTelefone, { value: valorTelefone, id: "telefone", label: false, placeholder: "(XX) 99999 - 9999", botaoDeLimpar: true, tamanho: "small", internacional: internacional, onChange: onChangeTelefone, 
                //  testar a baixo
                onKeyDown: function (event) {
                    if (event.key === "Enter" || event.key === "NumpadEnter") {
                        onAdicionarTelefone && onAdicionarTelefone();
                    }
                } }),
            quantidadeMaximaTelefones && listaTelefone && listaTelefone.length < quantidadeMaximaTelefones ? (react_1.default.createElement(Botao_1.Botao, { tamanho: "xsmall", exibirBotaoArrendondado: true, style: { padding: ".5rem", cursor: "pointer" }, estilo: "outlined", onClick: globalMu_1.default.validarTelefone(valorTelefone)
                    ? onAdicionarTelefone
                    : function () {
                        return setAjudaWhatsApp({
                            estado: "error",
                            texto: "Insira um telefone válido.",
                            icone: "warning",
                        });
                    } },
                react_1.default.createElement(Icone_1.Icone, { nome: "person_add", altura: "20px", largura: "20px", cor: Cores_1.Cores.GradacaoNeutros.CinzaFillMU600 }))) : (react_1.default.createElement("div", { style: { display: 'flex', alignItems: 'center', height: '100%' } },
                react_1.default.createElement(Tooltip_1.Tooltip, { estiloTooltip: "warning", mostrarDivider: false, descricaoTooltip: "Quantidade M\u00E1xima de N\u00FAmeros Atingida." },
                    react_1.default.createElement(Icone_1.Icone, { nome: "info", altura: "20px", largura: "20px", cor: Cores_1.Cores.MensagensDoSistema.AmareloMU }))))),
        ajudaWhatsApp && react_1.default.createElement(HelperText_1.HelperText, __assign({}, ajudaWhatsApp))));
    var renderChips = (react_1.default.createElement("div", { className: estiloWhatsAppCompartilhar.chipsWrapper },
        listaTelefone && listaTelefone.length > 0 && (react_1.default.createElement("div", { className: estiloWhatsAppCompartilhar.principal },
            react_1.default.createElement(Corpo_1.Corpo, { tipo: "caption", negrito: 400, cor: Cores_1.Cores.GradacaoNeutros.CinzaFillMU600, conteudo: "Principal:" }),
            react_1.default.createElement(Chip_1.Chip, { key: "chip-telefone-principal", estilo: "primary_dark", botaoFechar: true, onClose: function () {
                    return onRemoveTelefone && onRemoveTelefone(listaTelefone[0].numeroCompleto);
                }, onClick: function () { return onSelectTelefone && onSelectTelefone(listaTelefone[0]); }, titulo: react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(Icone_1.Icone, { nome: "person", altura: "20px", largura: "20px", cor: Cores_1.Cores.GradacaoNeutros.BrancoMU50 }),
                    react_1.default.createElement("p", { className: estiloWhatsAppCompartilhar.chipText, title: "+" + listaTelefone[0].numeroCompleto }, listaTelefone[0].ddi === "" || listaTelefone[0].ddi === "55"
                        ? globalMu_1.default.formatarTelefone(listaTelefone[0].numeroCompleto)
                        : listaTelefone[0].numeroCompleto)), style: { width: "fit-content", alignItems: "center" }, estado: true }))),
        listaTelefone && listaTelefone.length > 1 && (react_1.default.createElement("div", { className: estiloWhatsAppCompartilhar.copias },
            react_1.default.createElement(Corpo_1.Corpo, { tipo: "caption", negrito: 400, cor: Cores_1.Cores.GradacaoNeutros.CinzaFillMU600, conteudo: "C\u00F3pia:" }),
            react_1.default.createElement("div", { className: estiloWhatsAppCompartilhar.chips }, listaTelefone.slice(1).map(function (telefone, index) { return (react_1.default.createElement(Chip_1.Chip, { key: "chip-telefone-copia-[".concat(index, "]"), botaoFechar: true, onClose: function () {
                    return onRemoveTelefone && onRemoveTelefone(telefone.numeroCompleto);
                }, onClick: function () { return onSelectTelefone && onSelectTelefone(telefone); }, titulo: react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(Icone_1.Icone, { nome: "content_copy", altura: "20px", largura: "20px", cor: Cores_1.Cores.GradacaoNeutros.BrancoMU50 }),
                    react_1.default.createElement("p", { className: estiloWhatsAppCompartilhar.chipText, title: "+" + telefone.numeroCompleto }, telefone.ddi === "" || telefone.ddi === "55"
                        ? globalMu_1.default.formatarTelefone(telefone.numeroCompleto)
                        : telefone.numeroCompleto)), style: { width: "fit-content", alignItems: "center" }, estado: true })); }))))));
    var renderHeader = (react_1.default.createElement(Corpo_1.Corpo, { tipo: "caption", negrito: 400, cor: Cores_1.Cores.GradacaoNeutros.CinzaFillMU600, conteudo: "Para" }));
    var renderMensagem = (react_1.default.createElement("div", { className: estiloWhatsAppCompartilhar.secaoMensagem },
        react_1.default.createElement(Corpo_1.Corpo, { tipo: "caption", negrito: 400, cor: Cores_1.Cores.GradacaoNeutros.CinzaFillMU600, conteudo: "Mensagem" }),
        react_1.default.createElement(InputTextArea_1.InputTextArea, { label: false, placeholder: "Inserir Mensagem", valor: mensagem, quantidadeLinhaMaxima: 16, onChange: onChangeMensagem })));
    (0, react_1.useEffect)(function () {
        setAjudaWhatsApp(conteudoAjudaWhatsApp);
    }, [
        valorDdi,
        internacional,
        valorTelefone,
        mensagem,
        listaTelefone,
        conteudoAjudaWhatsApp,
        quantidadeMaximaTelefones,
    ]);
    return (react_1.default.createElement("div", { className: estiloWhatsAppCompartilhar.containerPai },
        react_1.default.createElement("div", { className: estiloWhatsAppCompartilhar.container },
            renderHeader,
            renderTelefone,
            renderChips),
        react_1.default.createElement("div", { style: { display: "flex", gap: "24px", width: "50%" } },
            react_1.default.createElement(Divider_1.Divider, { orientacao: "vertical" }),
            renderMensagem)));
};
exports.WhatsAppCompartilhar = WhatsAppCompartilhar;
